import React from 'react';
import { ProTable } from '@ant-design/pro-table';
const OriginalTable = ProTable;
export default class ContainerClass extends React.PureComponent {
    render() {
        const { forwardedRef, ...otherProps } = this.props;
        const columns = (this.props.columns || []).filter((item) => !item?.hidden);
        return React.createElement(OriginalTable, Object.assign({ ref: forwardedRef }, otherProps, { columns: columns }));
    }
}
